import BaseCard from 'components/Cards/BaseCard';
import SettingButton from '../../../../../components/SettingButton/SettingButton';
import { CARD_CLASS_NAMES } from '../../../../../config/floodDeviceConfig';

export default function ActionRequestsCard({ deviceSettings, setDeviceSettings, device, enabled }) {
  return (
    <BaseCard
      className={`shadow-sm ${CARD_CLASS_NAMES.card}`}
      header="Action Requests"
      headerClassName={CARD_CLASS_NAMES.cardHeader}
      bodyClassName={`d-flex flex-column gap-3 ${CARD_CLASS_NAMES.cardBody}`}
    >
      <SettingButton
        displayName="Image Request"
        settingName="imageRequest"
        deviceSettings={deviceSettings}
        setDeviceSettings={setDeviceSettings}
        device={device}
        enabled={enabled}
      />
      <SettingButton
        displayName="GPS Sync"
        settingName="gpsSync"
        deviceSettings={deviceSettings}
        setDeviceSettings={setDeviceSettings}
        device={device}
        enabled={enabled}
      />
    </BaseCard>
  );
}
